import { render } from "./AttributeComponent.vue?vue&type=template&id=3918c364&scoped=true"
import script from "./AttributeComponent.vue?vue&type=script&lang=js"
export * from "./AttributeComponent.vue?vue&type=script&lang=js"

import "./AttributeComponent.vue?vue&type=style&index=0&id=3918c364&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3918c364"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QRange from 'quasar/src/components/range/QRange.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn,QSelect,QToggle,QBtnToggle,QRange,QInnerLoading,QField});
